import { ComponentPropsWithoutRef, forwardRef } from 'react';
import styled from 'styled-components';

import inputMixin, { InputMixinProps } from 'design-system/mixins/input';
import { InputProps } from 'design-system/types/InputProps';

export interface TextAreaProps
  extends ComponentPropsWithoutRef<'textarea'>,
    Omit<InputProps, 'inputSize'> {}

const TextArea = styled('textarea')<InputMixinProps>`
  ${inputMixin};
  /* Don't cut off overflow text */
  padding-bottom: 0;
  font-family: ${({ theme }) => theme.text.fontFamily.base};
  height: ${({ theme }) => theme.element.height.xl};
  white-space: pre-wrap;
`;

const TextAreaWithStyle = forwardRef<HTMLTextAreaElement, TextAreaProps>(function TextAreaWithStyle(
  { size, ...props },
  ref,
) {
  return <TextArea aria-invalid={props.hasError === true} ref={ref} {...props} $size={size} />;
});

export default TextAreaWithStyle;
